﻿import $ from 'jquery';

declare global {
  interface JQuery {
    required(): JQuery;
    notRequired(): JQuery;
    isRequired(): boolean;
    isNotRequired(): boolean;
    toggleRequired(condition: boolean): JQuery;
  }
}

(function ($) {
  $.fn.required = function () {
    $(this).each(function () {
      var $self = $(this);
      $self.attr('data-required', 'data-required');
    });
    return $(this);
  };
  $.fn.notRequired = function () {
    $(this).each(function () {
      var $self = $(this);

      $self.removeAttr('data-required');
    });

    return $(this);
  };
  $.fn.isRequired = function () {
    return $(this).is('[data-required]');
  }
  $.fn.isNotRequired = function () {
    return !$(this).isRequired();
  }
  $.fn.toggleRequired = function (condition) {
    if (condition)
      return $(this).required();
    else
      return $(this).notRequired();
  }
})($);